export default __webpack_public_path__ + "static/media/icon-eye-black.fa58223a.svg";